import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';

@Component({
    selector: 'app-cam-empty-state',
    templateUrl: './cam-empty-state.component.html',
    styleUrls: ['./cam-empty-state.component.scss'],
    imports: [NgIf, RouterLink]
})
export class CamEmptyStateComponent implements OnInit, OnDestroy {
  @Input() heading: string = 'No Data Available';
  @Input() content: string = '';
  @Input() content1: string = 'Try searching again';
  @Input() navigateTo: string = ''; // Default route
  @Input() width: string = '100%';
  @Output() myEvent = new EventEmitter<string>();
  @Input() IsShow: boolean = true;
  @Input() isProfileViewRestricted: boolean = false;
  @Input() disableNavigation: boolean = false;
  private destroy$ = new Subject<void>();
  dynamicContent:any;
  numberOfResult: number = 0;
constructor(private contentService:CompanyManagementContentService,private readonly _camService:CamService,private readonly travelerManagement: TravelerManagement,){
    if(this.navigateTo == '/cam/saved-dependents/dependent-information-form'){
      sessionStorage.setItem('dptState','1');
    }
}
ngOnInit(){
  this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.dynamicContent = res;
  });
}
  emitEvent() {
    
    this.myEvent.emit(this.navigateTo);
  }

  AddNow(event?: Event) {
    // GTM Event Call
    this.travelerManagement.saved_card_clickBackStep(this.numberOfResult, 'Add');
    if (this.disableNavigation) {
      event?.preventDefault();
      event?.stopPropagation();
    }
    
    this.emitEvent();
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
